import React from 'react'

type CrisisBannerLayoutProps = {
  child: JSX.Element
}

export const CrisisBannerLayout = (props: CrisisBannerLayoutProps) => (
  <aside
    className="banner"
    role="alert"
    aria-labelledby="a11y-banner-title a11y-banner-text"
  >
    <div className="banner__inner container--m gutter--m bg">
      <div id="a11y-banner-text" className="banner__text">
        {props.child}
      </div>
    </div>
  </aside>
)
